import request from '@/utils/http'
import { decodeUrl } from '@/utils/urlMapper'
// 查询书籍信息（探索出版物）列表
export const listBookPage = (data = {}) => {
  return request({
    url: decodeUrl('bookPage'),
    method: 'post',
    data
  })
}

// 查询书籍详情
export const getBookDetail = (bookId) => {
  return request({
    url: decodeUrl('bookDetail'),
    method: 'get',
    params: { bookId }
  })
} 
// 添加书籍点击记录
export const addReport = (data) => {
  return request({
    url: decodeUrl('addReport'),
    method: 'post',
    data
  })
}
// 查询相关书籍推荐
export const listRelatedBook = (bookId) => {
  return request({
    url: decodeUrl('relatedBook'),
    method: 'get',
    params: { bookId }
  })
}

// 拼接电子书下载地址（走文章下载接口）
export const getBookDownloadUrl = (resource) => {
  if (!resource) return ''
  const base = process.env.VUE_APP_BASE_API || '/api'
  return `${base}${decodeUrl('bookPdf')}?resource=${encodeURIComponent(resource)}`
}
